<script setup>
import {ref, onBeforeMount, computed, nextTick} from 'vue'
import YTCard from "@/components/YTCard/newIndex.vue";
import YTRadio from "@/components/YTRadio/index.vue";
import YTAddress from "@/components/YTAddress/index.vue";
import YTAvatarUpload from "@/components/YTAvatarUpload/index.vue";
import {detailTenant, listTenant} from "@/api/user/user.js";
import {listTenantOrganizeNotStoreIdIgnore} from "@/api/tenant/tenant.js";
import YTPartnerSelectPanel from "../YTPartnerSelectPanel/index.vue"
import {getRoute} from "@/hooks/getRoute.js";

const {route} = getRoute()

const props = defineProps({
  // 是否编辑模式
  isEdit: {
    type: Boolean,
    default: false
  },
  // 双向绑定值
  modelValue: {
    required: true,
    type: Object,
  },
})

const emit = defineEmits(['success'])
onBeforeMount(async () => {
  if (!props.isEdit && route.query.tenantId) {
    // 查询商家信息
    await handleGetTenantDetail(route.query.tenantId)
  }
})

// 处理获取商家详情
const handleGetTenantDetail = async (tenantId) => {
  try {
    loading.value = true
    const res = await detailTenant(tenantId)
    if (!res) return
    ruleForm.value.tenantId = res.tenantId
    ruleForm.value.tenantName = res.name
    ruleForm.value.certificationType = res.certificationType
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = true
  }
}

// 加载状态
const loading = ref(false)

/*商家列表相关*/
// 商家列表
const tenantList = ref([])
// 商家列表加载状态
const tenantLoading = ref(false)
// 商家总数
const totalTenant = ref(0)
// 商家列表当前页数
const pageTenant = ref(1)
// 商家列表页长
const pageSizeTenant = ref(5)
// 处理选择商家改变
const handleTenantChange = (e) => {
  const tenant = tenantList.value.find(item => item.tenantId === e)
  ruleForm.value.tenantId = tenant.tenantId
  ruleForm.value.tenantName = tenant.name
  ruleForm.value.bikeStoreId = null
  ruleForm.value.certificationType = tenant.certificationType
}
// 处理商家翻页
const handleChangeTenantPage = (e) => {
  pageTenant.value = e
  handleGetTenantList()
}
// 搜索关键字缓存
const keywordTenant = ref()
// 搜索触发函数
const handleRemoteSearch = (keyword) => {
  keywordTenant.value = keyword
  pageTenant.value = 1
  handleGetTenantList()
}
// 获取商家列表
const handleGetTenantList = async () => {
  tenantLoading.value = true
  const page = {
    page: pageTenant.value,
    pageSize: pageSizeTenant.value,
  }
  let param = {
    keyword: keywordTenant.value || null
  }
  const res = await listTenant(page, param)
  tenantList.value = res.list
  totalTenant.value = parseInt(res.total)
  console.log(res)
  tenantLoading.value = false
}

/*合作身份列表相关*/
// 合作身份列表
const partnerList = ref([])
// 合作身份列表加载状态
const partnerLoading = ref(false)
// 获取合作身份列表
const handleGetPartnerList = async () => {
  partnerLoading.value = true
  let page = {
    page: 1,
    pageSize: 100,
  }
  let param = {
    tenantId: ruleForm.value.tenantId,
    storeId: ruleForm.value.storeId
  }
  const res = await listTenantOrganizeNotStoreIdIgnore(page, param)
  partnerList.value = res.list
  console.log(res)
  partnerLoading.value = false
}
// 处理删除合作身份tags
const handleClosePartnerStoresTags = (index) => {
  console.log("index", index)
  ruleForm.value.partnerStores.splice(index, 1)
}

/*表单相关*/
// 表单锚点
const ruleFormRef = ref()
// 表单信息，实现「双向绑定」
const ruleForm = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
// 俱乐部logo校验规则
const checkImagesList = (rule, value, callback) => {
  const listLength = boxUploadRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张俱乐部Logo'))
  }
  callback()
}
// 俱乐部名称校验规则
const checkClubName = (rule, value, callback) => {
  if (!ruleForm.value.name) {
    return callback(new Error("俱乐部名称（中文）不能为空！"))
  }
  if (!ruleForm.value.nameEn) {
    return callback(new Error("俱乐部名称（English）不能为空！"))
  }
  return callback()
}
// 俱乐部地址校验规则
const checkAddress = (rule, value, callback) => {
  if (!addressCode.value) return callback(new Error("请选择俱乐部所在地区"))
  return callback()
}
// 默认校验规则
const rulesOne = {
  storeLogo: [
    {required: true, validator: checkImagesList, trigger: "blur"},
  ],
  name: [
    {required: true, validator: checkClubName, trigger: "blur"},
  ],
  tenantId: [
    {required: true, message: "请选择俱乐部所属商家", trigger: "change"},
  ],
  storeAddress: [
    { required: true, validator: checkAddress, trigger: 'change' }
  ],
  contactName: [
    {required: true, message: "请填写俱乐部负责人", trigger: "change"},
  ],
  phone: [
    {required: true, message: "请填写俱乐部联系电话", trigger: "change"},
  ]
}
// 表单校验规则
const rules = ref(rulesOne)
// 处理协助运营状态修改
const handleAssistStateChange = (state) => {
  if (state === ruleForm.value.assistsOperation) return console.log("点击的与当前值相同，不赋值")
  ElMessageBox.confirm(
      `确认${state ? '开通' : '关闭'}协助运营的权限吗？`,
      '温馨提示',
      {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }
  ).then(() => {
    ruleForm.value.assistsOperation = state
  }).catch((e) => {
    console.log("点击了取消")
  })
}
// 表单校验
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      await createTenantClub()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 创建商家俱乐部
const createTenantClub = () => {
  emit("success", ruleForm)
}
// 缓存省市区code信息
const addressCode = ref()
// 缓存收件地址code信息
const recipientAddressCode = ref()
// 处理选择所属区域
const handleSelectAddress = (data) => {
  ruleForm.value.storeAddress.provinceCode = null
  ruleForm.value.storeAddress.cityCode = null
  ruleForm.value.storeAddress.districtCode = null
  console.log("data:", data)
  addressCode.value = data.value
  ruleForm.value.storeAddress.provinceCode = data.value[0]
  ruleForm.value.storeAddress.cityCode = data.value[1]
  ruleForm.value.storeAddress.districtCode = data.value.length > 2 ? data.value[2] : null
  ruleFormRef.value.validateField("storeAddress")
}
// 处理选择收件地址
const handleSelectRecipientAddress = (data) => {
  ruleForm.value.recipientInfo.recipientAddress.provinceCode = null
  ruleForm.value.recipientInfo.recipientAddress.cityCode = null
  ruleForm.value.recipientInfo.recipientAddress.districtCode = null
  recipientAddressCode.value = data.value
  ruleForm.value.recipientInfo.recipientAddress.provinceCode = data.value[0]
  ruleForm.value.recipientInfo.recipientAddress.cityCode = data.value[1]
  ruleForm.value.recipientInfo.recipientAddress.districtCode = data.value.length > 2 ? data.value[2] : null
}
// 反显省市区code信息
const handleReviewAddressCode = (data) => {
  addressCode.value = data
}
// 反显收件地址code信息
const handleReviewRecipientAddressCode = (data) => {
  recipientAddressCode.value = data
}

/*上传图片组件相关*/
// Logo图片上传组件锚点
const boxUploadRef = ref();
const handlePicSuccess = (url) => {
  ruleForm.value.storeLogo = null;
  ruleForm.value.storeLogo = url[0];
  ruleFormRef.value.validateField("storeLogo");
  loading.value = false;
};
// 处理Logo图片反显
const handleReviewPic = (reviewList) => {
  boxUploadRef.value.handleReview(reviewList);
};

/*中英文切换输入框相关Tab*/
// 俱乐部名称tab
const clubNameTab = ref("zh")
// 简介tab
const summaryTab = ref("zh")
// 详细介绍tab
const descriptionTab = ref("zh")

/*合作身份面板弹窗相关*/
// 面板锚点
const YTPartnerSelectPanelRef = ref()
// 处理面板打开
const handleOpenPanel = async () => {
  if (!ruleForm.value.tenantId) return ElMessage.error("请先选择所属商家")
  YTPartnerSelectPanelRef.value.handleOpen()
  await handleGetPartnerList()
}
// 处理面板确认
const handlePanelConfirm = (stores) => {
  console.log("stores", stores)
  ruleForm.value.partnerStores = stores
}

defineExpose({
  handleReviewAddressCode,
  handleReviewRecipientAddressCode,
  handleReviewPic
})
</script>

<template>
  <div class="create_container_box flex">
    <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        style="height: 100%;width: 100%;"
        class="flex"
        size="large"
    >
      <div class="create_wrapper flex_1">
        <YTCard :title="`基本信息`">
          <template #container>
            <el-form-item prop="storeLogo">
              <YTAvatarUpload :ali-oss-path="'STORE_LOGO'"
                  ref="boxUploadRef"
                  :isReplaceMode="true"
                  :isLogoMode="true"
                  :limit="1"
                  :width="80"
                  :height="80"
                  :file-size="1"
                  :isRequired="true"
                  :tips="`添加俱乐部logo，照片会显示在你使用的账号平台上。`"
                  @progress="loading = true"
                  @success="handlePicSuccess"
              ></YTAvatarUpload>
            </el-form-item>
            <el-form-item label="俱乐部名称：" prop="name">
              <el-tabs
                  v-model="clubNameTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input style="width: 250px" maxlength="20" show-word-limit v-model="ruleForm.name" placeholder="请输入俱乐部名称"></el-input>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input style="width: 250px" maxlength="60" show-word-limit v-model="ruleForm.nameEn" placeholder="Please enter the name of the club"></el-input>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="所属商家：" prop="tenantId">
              <el-select
                  v-model="ruleForm.tenantId"
                  placeholder="所属商家"
                  size="large"
                  style="width: 240px;"
                  :loading="tenantLoading"
                  @change="handleTenantChange"
                  filterable
                  remote
                  remote-show-suffix
                  :remote-method="handleRemoteSearch"
              >
                <el-option
                    v-for="item in tenantList"
                    :key="`tenantId${item.tenantId}`"
                    :label="item.name"
                    :value="item.tenantId"
                />
                <template v-if="!loading && !tenantList.some(res => res.tenantId === ruleForm.tenantId) && ruleForm.tenantId" #header>
                  当前已选：
                  <el-option
                      :label="ruleForm.tenantName"
                      :value="ruleForm.tenantId"
                  />
                </template>

                <template #footer>
                  <div class="flex_center">
                    <el-pagination
                        size="small"
                        background
                        layout="prev, pager, next"
                        :total="totalTenant"
                        class="mt-4"
                        v-model:current-page="pageTenant"
                        v-model:page-size="pageSizeTenant"
                        @current-change="handleChangeTenantPage"
                    />
                  </div>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="所在地区：" prop="storeAddress">
              <YTAddress ref="YTAddressRef" :title="'所在地区'" :address-code="addressCode" @select="handleSelectAddress"></YTAddress>
            </el-form-item>
            <el-form-item label="负责人：" prop="contactName">
              <el-input v-model="ruleForm.contactName" style="width: 250px;" placeholder="负责人"/>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input maxlength="12" v-model="ruleForm.phone" show-word-limit style="width: 250px;" placeholder="联系电话"/>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`推荐官`">
          <template #container>
            <el-form-item label="姓名：" prop="">
              <el-input v-model="ruleForm.referralOfficer.name" style="width: 250px;" placeholder="推荐官姓名"/>
            </el-form-item>
            <el-form-item label="联系电话：" prop="">
              <el-input v-model="ruleForm.referralOfficer.phone" style="width: 250px;" placeholder="推荐官联系电话"/>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`商家认证类型`">
          <template #container>
            <el-form-item label="认证类型：" prop="certificationType">
              <div v-if="ruleForm?.certificationType === 'LEGAL_PERSON'">
                法人企业
              </div>
              <div v-else-if="ruleForm?.certificationType === 'NATURAL_PERSON'">
                自然人
              </div>
              <div v-else>
                未知
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`关联合作身份`">
          <template #container>
            <el-form-item label="选择合作身份">
              <div>
                <div>
                  <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in ruleForm.partnerStores" :key="`cachePartnerList${tag.storeName}-${tagIndex}`" closable type="success" @close="handleClosePartnerStoresTags(tagIndex)">
                    {{ tag.storeName }}
                  </el-tag>
                </div>
                <div class="flex_left">
                  <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleOpenPanel"></v-icon>
                  <div class="tips_default">
                    请先选择所属商家，再选择关联合作身份
                  </div>
                </div>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`简介和详细介绍`">
          <template #container>
            <el-form-item label="简介：">
              <el-tabs
                  v-model="summaryTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input maxlength="34" v-model="ruleForm.summary" show-word-limit style="width: 250px;" placeholder="请用一句话介绍自己吧"/>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input maxlength="102" v-model="ruleForm.summaryEn" show-word-limit style="width: 250px;" placeholder="Please introduce yourself in one sentence"/>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="详细介绍：">
              <el-tabs
                  v-model="descriptionTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input maxlength="200" v-model="ruleForm.description" show-word-limit type="textarea" :rows="5" resize="none" style="width: 300px;" placeholder="一句话不够展现？快来这里具体说说吧，会有更多会员对你感兴趣哦"/>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input maxlength="600" v-model="ruleForm.descriptionEn" show-word-limit type="textarea" :rows="5" resize="none" style="width: 300px;" placeholder="One sentence is not enough to show it? Come here and tell me in detail. More members will be interested in you"/>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`收件信息`">
          <template #container>
            <el-form-item label="收件人：">
              <el-input v-model="ruleForm.recipientInfo.recipientName" style="width: 250px;" placeholder="收件人"/>
            </el-form-item>
            <el-form-item label="联系电话：">
              <el-input maxlength="12" v-model="ruleForm.recipientInfo.recipientPhone" show-word-limit style="width: 250px;" placeholder="联系电话"/>
            </el-form-item>
            <el-form-item label="收件地址：">
              <YTAddress class="mg_r_1" :title="'收件地址'" :addressCode="recipientAddressCode" @select="handleSelectRecipientAddress"></YTAddress>
              <el-input v-model="ruleForm.recipientInfo.recipientAddress.addressDetail" style="width: 250px;" placeholder="收件地址"/>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`协助运营`" prop="assistsOperation">
          <template #container>
            <div class="flex_left mg_b_2">
              <div class="flex mg_r_2">
                <YTRadio
                    :show="ruleForm.assistsOperation === true"
                    @click="handleAssistStateChange(true)"
                ></YTRadio>
                <div class="mg_l_1">开通</div>
              </div>
              <div class="flex">
                <YTRadio
                    :show="ruleForm.assistsOperation === false"
                    @click="handleAssistStateChange(false)"
                ></YTRadio>
                <div class="mg_l_1">关闭</div>
              </div>
            </div>
          </template>
        </YTCard>
        <el-form-item label=" ">
          <div>
            <v-row>
              <v-col>
                <v-btn color="primary" @click="submit">保存</v-btn>
              </v-col>
            </v-row>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
  <YTPartnerSelectPanel :loading="partnerLoading" ref="YTPartnerSelectPanelRef" :selectedStores="ruleForm.partnerStores" :tableData="partnerList" @confirm="handlePanelConfirm"></YTPartnerSelectPanel>
</template>

<style lang="scss" scoped>
.create_container_box {
  width: 100%;
  height: 100%;
  .create_wrapper {
    background: #fff;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    padding-right: 20px;
  }
}
.add_member_tips_member {
  font-weight: 500;
  font-size: 14px;
  color: #684fa2;
}
</style>
